"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StringUtils = require("./StringUtils");
var KeyMapFuncs_1 = require("./KeyMapFuncs");
var LangUtils_1 = require("./LangUtils");
var toSortNumber = function (o) {
    if (LangUtils_1.isNumber(o)) {
        return o;
    }
    if (LangUtils_1.isDate(o)) {
        return o.getTime();
    }
    if (LangUtils_1.isString(o)) {
        return parseInt(o);
    }
    if (LangUtils_1.isBoolean(o)) {
        return o ? 1 : 0;
    }
    return 0;
};
exports.toSortNumber = toSortNumber;
var toSortString = function (o) {
    var s;
    if (LangUtils_1.isString(o)) {
        s = o;
    }
    else if (LangUtils_1.isObject(o)) {
        s = String(o);
        if (s === String({})) {
            s = JSON.stringify(o);
        }
    }
    else {
        s = String(o);
    }
    return s;
};
exports.toSortString = toSortString;
var compare = function (l, r, sort) {
    var result;
    if (LangUtils_1.isNumber(l)) {
        result = r !== undefined && r !== null ? l - toSortNumber(r) : 1;
    }
    else if (LangUtils_1.isDate(l)) {
        result = r ? l.getTime() - toSortNumber(r) : 1;
    }
    else if (LangUtils_1.isString(l)) {
        result = r !== undefined && r !== null ? l.localeCompare(toSortString(r)) : 1;
    }
    else if (LangUtils_1.isBoolean(l)) {
        result = r !== undefined && r !== null ? (l ? 1 : 0) - toSortNumber(r) : 1;
    }
    else if (LangUtils_1.isObject(l)) {
        result = r !== undefined && r !== null ? toSortString(l).localeCompare(toSortString(r)) : 1;
    }
    else {
        result = r ? -1 : 0;
    }
    if (sort && sort.descending) {
        result = 0 - result;
    }
    return result;
};
exports.compare = compare;
var sort = function (items, sort, keyMap) {
    if (keyMap === void 0) { keyMap = KeyMapFuncs_1.defaultKeyMap; }
    return items && sort && StringUtils.isNotBlank(sort.field)
        ? items.sort(function (a, b) { return compare(keyMap(a, sort.field), keyMap(b, sort.field), sort); }) : items;
};
exports.sort = sort;
